<template>
  <div>
    <v-row>
      <v-col cols="12" md="6" sm="12">
        <AppSectionHero :section-number="0">
          <template v-slot:title>{{
            $t("content.sections.outro.title")
          }}</template>
        </AppSectionHero>
        <p>
          {{ $t(`content.sections.outro.intro`) }}
        </p>
        <div class="text-center">
          <v-btn
            v-if="!filtersShown"
            color="primary"
            tile
            @click="showFilters"
            >{{ $t(`interface.callToAction`) }}</v-btn
          >
          <v-icon v-else>{{ sidePanelPointer }}</v-icon>
        </div>
      </v-col>
      <v-col cols="12" md="6" sm="12">
        <AppSectionHero :section-number="0">
          <template v-slot:title>{{
            $t("content.sections.outro.report")
          }}</template>
        </AppSectionHero>
        <p>
          {{ $t("content.sections.outro.reportIntro") }}
        </p>
        <div class="text-center">
          <a
            href="https://cdn.pngk.org/Projects/191118_Dashboard_Development_for_Data_Driven_Dialogue.pdf"
            target="_blank"
            class="text-center"
          >
            <v-btn color="primary" tile>{{
              $t(`interface.downloadReport`)
            }}</v-btn>
          </a>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { mdiArrowLeft, mdiArrowRight } from "@mdi/js";
import AppSectionHero from "@/components/AppSectionHero.vue";
export default {
  components: {
    AppSectionHero
  },
  data() {
    return {
      icon: {
        left: mdiArrowLeft,
        right: mdiArrowRight
      }
    };
  },
  computed: {
    ...mapState(["filtersShown"]),
    sidePanelPointer() {
      return this.$vuetify.rtl ? this.icon.right : this.icon.left;
    }
  },
  methods: {
    ...mapActions(["showFilters"])
  }
};
</script>